import { slugPath } from '../utils/slugPath';

export const WHOLESALE_PREFIX = '/vairumtirdznieciba';

export enum PublicRoute {
  HOME = '/',
  MAP = '/karte',
  SEARCH_PAGE = '/meklesana',

  PRODUCTS_ALL = '/produkti/visi',
  PRODUCTS_ALL_NEW = '/produkti/visi/jaunie',
  PRODUCTS_ALL_DISCOUNTED = '/produkti/visi/akcijas',
  PRODUCT_PAGE = '/produkts/:slug/:id',

  FARMS_ALL = '/saimniecibas/visas',
  FARM_PAGE = '/saimnieciba/:slug/:id',

  CART_PAGE = '/grozs',
  USER_ORDER = '/pasutijums',
  PROFILE = '/profils/:tab',

  TERMS_OF_USE = '/lietosanas-noteikumi',
  ICONS_PAGE = '/icons',
  TEST_PAGE = '/test',
  ERROR_500 = '/500',
  NOT_FOUND = '*',

  // Auth
  LOGIN = '/pieslegties',
  MOBILE_AUTH_ENTRY = '/mobila-autentifikacija',
  REGISTER = '/registreties',
  EMAIL_CONFIRM = '/e-pasta-apstiprinasana',
  CONFIRMATION = '/apstiprinajums',
  RESET_PASSWORD = '/paroles-atiestatisana',
  NEW_PASSWORD = 'password/reset/:token',
  APPROVE_REGISTRATION = '/registracijas-apstiprinasana',

  // Wholesale
  WHOLESALE_HOME = '/vairumtirdznieciba',
  WHOLESALE_PRODUCTS = '/vairumtirdznieciba/produkti',
  WHOLESALE_MAP = '/vairumtirdznieciba/karte',
  WHOLESALE_FARMS_ALL = '/vairumtirdznieciba/saimniecibas/visas',
  WHOLESALE_PRODUCTS_ALL = '/vairumtirdznieciba/produkti/visi',
  WHOLESALE_PRODUCTS_ALL_NEW = '/vairumtirdznieciba/produkti/visi/jaunie',
  WHOLESALE_PRODUCTS_ALL_DISCOUNTED = '/vairumtirdznieciba/produkti/visi/akcijas',
  WHOLESALE_PRODUCT_PAGE = '/vairumtirdznieciba/produkts/:slug/:id',
  WHOLESALE_FARM_PAGE = '/vairumtirdznieciba/saimnieciba/:slug/:id',
  WHOLESALE_LISTINGS = '/vairumtirdznieciba/sludinajumi',
  WHOLESALE_LISTING_DETAIL = '/vairumtirdznieciba/sludinajumi/:id',
  WHOLESALE_LISTING_SUMMARY = '/vairumtirdznieciba/sludinajumi/:listingId/kopsavilkums',
  WHOLESALE_CART = '/vairumtirdznieciba/grozs',
}

type Id = string | number | null | undefined;
type Slug = string | null | undefined;

export const publicPath = {
  product: (slug: Slug, id: Id) => `/produkts/${slugPath(slug, id)}`,
  farm: (slug: Slug, id: Id) => `/saimnieciba/${slugPath(slug, id)}`,
  profile: (tab: string) => `/profils/${tab}`,
  giftSets: () => `${PublicRoute.PRODUCTS_ALL}?services=8`,

  // Wholesale
  wholesaleProduct: (slug: Slug, id: Id) =>
    `${WHOLESALE_PREFIX}/produkts/${slugPath(slug, id)}`,
  wholesaleFarm: (slug: Slug, id: Id) =>
    `${WHOLESALE_PREFIX}/saimnieciba/${slugPath(slug, id)}`,
  wholesaleListingDetail: (id: Id) => `${PublicRoute.WHOLESALE_LISTINGS}/${id}`,
  wholesaleListingSummary: (id: Id) =>
    `${PublicRoute.WHOLESALE_LISTINGS}/${id}/kopsavilkums`,
};

export default PublicRoute;
